import styled from "styled-components";
export const COLLAPSIBLE_TRANSITION_DURATION_MS = 300;
export const COLLAPSIBLE_TRANSITION_EASING = "ease";
export const COLLAPSIBLE_TRANSITION_DELAY = "0s";
export const StyledContainer = styled.div.withConfig({ displayName: "StyledContainer_APC-7281-productShell", componentId: "sc-1e1ilgs" })(({ animate }) => ({
    transition: `${["left", "right"].includes(animate) ? "width" : "height"} ${COLLAPSIBLE_TRANSITION_DURATION_MS}ms ${COLLAPSIBLE_TRANSITION_EASING} ${COLLAPSIBLE_TRANSITION_DELAY}`,
    padding: 0,
    border: 0,
    margin: 0,
    height: ["left", "right"].includes(animate) ? "100%" : 0,
    width: ["top", "bottom"].includes(animate) ? "100%" : 0,
    position: "relative",
    overflow: "hidden",
}));
export const StyledContentContainer = styled.div.withConfig({ displayName: "StyledContentContainer_APC-7281-productShell", componentId: "sc-1pa3s12" })(({ isCollapsed }) => ({
    padding: 0,
    border: 0,
    margin: 0,
    transition: `visibility ${COLLAPSIBLE_TRANSITION_DURATION_MS}ms`,
    visibility: isCollapsed ? "hidden" : "visible",
}));
//# sourceMappingURL=Collapsible.style.js.map